import { BettingActivityService as BettingActivityDataService } from "@api-services/betting-activity/BettingActivityApiService";
import { UserActivityResponse } from "@api-types/betting-activity/UserActivityResponse";
import { BettingActivityResponse } from "@api-types/betting-activity/BettingActivityResponse";

import { getAgencyId, getShopId } from "@utils";
import { getCurrentCulture } from "@utils";
import { LazyImportWithLoadFailHandle as lazy } from "@lib/lazy-import-with-guard/LazyImportWithGuard";
import { ErrorResponse, Response } from "@models/Models";

const loadFailPath = `/${getCurrentCulture()}/app-update`;
// prettier-ignore
const AgencyUserApiService = lazy(loadFailPath, ()=>import("@api-services/user/AgencyUserApiService"));

class BettingActivityService {
	private bettingActivityDataService: BettingActivityDataService;

	constructor() {
		this.bettingActivityDataService = new BettingActivityDataService();
	}

	async getBettingActivityData() {
		try {
			const filter = {
				Filter: {
					AccessChannels: {
						Agencies: null,
						Shops: [
							{
								AgencyId: getAgencyId(),
								Id: getShopId(),
							},
						],
					},
					Parameters: [
						{
							Column: "StartDate",
							Value: "30",
						},
					],
				},
				Paging: null,
			};

			const userActivityResponse =
				await this.bettingActivityDataService.fetchUserAccountActivity(
					filter
				);
			const bettingActivityResponse =
				await this.bettingActivityDataService.fetchUserBettingActivity(
					filter
				);

			let userActivity = null;
			let bettingActivity = null;

			if (
				userActivityResponse.result != null &&
				userActivityResponse.result.length > 0
			) {
				const activity = userActivityResponse.result[0];
				if (activity.NumberOfTransactions > 0) {
					userActivity = userActivityResponse.result;
				}
			}

			if (
				bettingActivityResponse.result != null &&
				bettingActivityResponse.result.length > 0
			) {
				const activity = bettingActivityResponse.result[0];
				if (activity.NumberOfBets > 0) {
					bettingActivity = bettingActivityResponse.result;
				}
			}

			return new Response<BettingActivity>({
				userActivity: userActivity,
				bettingActivity: bettingActivity,
			});
		} catch (error) {
			throw new ErrorResponse(error);
		}
	}

	async updateBettingActivityReview() {
		try {
			await (
				await AgencyUserApiService
			).default.updateBettingActivityReview();
		} catch (error) {
			throw new ErrorResponse(error);
		}
	}
}

export default new BettingActivityService();

export type BettingActivity = {
	// TODO
	userActivity: UserActivityResponse["result"] | null;
	bettingActivity: BettingActivityResponse["result"] | null;
};
